import { apiClient } from './client';

export async function getTenantProvisioningPlan(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/provisioning-plan`);
  return data;
}

export async function startTenantProvisioningRun(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/provisioning/runs`, payload);
  return data;
}

export async function verifyTenantDatabaseConnection(tenantId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/database/verify-connection`);
  return data;
}

export async function verifyTenantTestSeed(tenantId) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/database/test-seed/verify`);
  return data;
}

export async function getTenantProvisioningRunById(runId) {
  const { data } = await apiClient.get(`/api/system/tenant-provisioning-runs/${runId}`);
  return data;
}

export async function getTenantProvisioningRunSteps(runId) {
  const { data } = await apiClient.get(`/api/system/tenant-provisioning-runs/${runId}/steps`);
  return data;
}

export async function getTenantProvisioningRunEvents(runId) {
  const { data } = await apiClient.get(`/api/system/tenant-provisioning-runs/${runId}/events`);
  return data;
}

export async function runTenantProvisioningDryRun(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/provisioning/dry-run`, payload);
  return data;
}

export async function runTenantProvisioning(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/provisioning/provision`, payload);
  return data;
}

export async function runTenantProvisioningHealthCheck(tenantId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/provisioning/health-check`, payload);
  return data;
}

export async function rollbackTenantProvisioningRun(tenantId, runId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/tenants/${tenantId}/provisioning/runs/${runId}/rollback`, payload);
  return data;
}

export async function getTenantProvisioningRuns(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/provisioning-runs`, { params });
  return data;
}

export async function getTenantProvisioningRun(tenantId, runId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/provisioning-runs/${runId}`);
  return data;
}

export async function getTenantProvisioningEvents(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/provisioning-events`, { params });
  return data;
}

export async function getTenantDatabaseHealthChecks(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/database-health-checks`, { params });
  return data;
}

export async function getTenantProvisioningOverview(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-provisioning/overview', { params });
  return data;
}

export async function getAllTenantProvisioningRuns(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-provisioning/runs', { params });
  return data;
}

export async function getAllTenantProvisioningEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-provisioning/events', { params });
  return data;
}

export async function getAllTenantProvisioningHealthChecks(params = {}) {
  const { data } = await apiClient.get('/api/system/tenant-provisioning/health-checks', { params });
  return data;
}

export async function getPortalTenantProvisioningStatus(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/provisioning-status`);
  return data;
}
